const initialState = {
    isLoading: true,
    data: {},
};

const upgradeToPowerReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_POPUP_CONTENT':
            return {
                ...state,
                isLoading: true,
            };
        case 'FETCH_POPUP_CONTENT_SUCCESS':
            return {
                isLoading: false,
                data: action.data,
            };
        case 'FETCH_POPUP_CONTENT_FAILED':
            return {
                ...state,
                isLoading: false,
                data: {},
            };
        default:
            return state;
    }
};

export default upgradeToPowerReducer;
